import { PureComponent } from "react";
import classnames from "classnames";
import ButtonLinkComponent from "components/core/button-link/button-link-component";
import LottieAnimationComponent from "../lottie-animtaion/lottie-animation-component";
import { StyledButtonWithAnimationComponent } from "./button-with-animation-component.scss";

let INITIAL_LOTTIE_ANIMATION_CONFIG = {
  animation: {
    jsonPath: "/static/lottie/arrow-swirl-left.json",
    loop: false,
    autoplay: false,
    playOnlyWhenVisible: true
  },
  style: { height: "100%" }
};

const FIRE_ACTION_FRAME = 27;

export default class ButtonWithAnimationComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.bounceSignup = this.bounceSignup.bind(this);
    INITIAL_LOTTIE_ANIMATION_CONFIG.fireActionOnFrame = {
      frame: FIRE_ACTION_FRAME,
      action: this.bounceSignup
    };
    this.state = { animated: false };
  }

  bounceSignup() {
    if (this.state.animated) return;

    this.setState({ animated: true }, () => {
      setTimeout(() => {
        this.setState({ animated: false });
      }, 2000);
    });
  }

  getLottieConfig(color) {
    let lottieConfig = { ...INITIAL_LOTTIE_ANIMATION_CONFIG };
    lottieConfig.style = { ...lottieConfig.style, color };
    return lottieConfig;
  }

  render() {
    const { lottie, withAnimation, button, direction, textColor } = this.props;
    const lottieConfig = this.getLottieConfig(textColor);
    return (
      <StyledButtonWithAnimationComponent className={classnames("button-with-animation-component", { [direction]: direction })}>
        <div className="inline-flex-wrapper">
          <div className={classnames("button-wrapper", { "bounce-button": this.state.animated })}>
            <ButtonLinkComponent {...button}>{button.text}</ButtonLinkComponent>
          </div>
          {withAnimation && (
            <div className="lottie-animation-wrapper">
              <LottieAnimationComponent {...lottieConfig} />
            </div>
          )}
        </div>
      </StyledButtonWithAnimationComponent>
    );
  }
}

ButtonWithAnimationComponent.defaultProps = {
  button: {
    color: "brand-dark-blue",
    href: "/help",
    text: "Contact Us",
    fontSize: "16px",
    textColor: "white"
  },
  withAnimation: true
};
